import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { Row, Table, Divider, Col } from 'antd';
import Filters from 'components/filters';
import { useBoardDocsLogs } from './useBoardDocLogs';
import { useTranslation } from 'react-i18next';
import { ExcelIcon } from 'icons';

const LogsPage = () => {
  const {
    data,
    columns,
    filters,
    loading,
    handleChangeFilters,
    handleLogsDownloadExcel,
    handleCloseFilter,
    onChangeTableFilter,
  } = useBoardDocsLogs();
  const { t } = useTranslation();
  return (
    <>
      <Row style={{ marginTop: '20px', marginRight: '20px' }} justify='end'>
        <Col>
          <Button
            big
            type={'green'}
            iconMargin
            width={'138px'}
            disabled={loading}
            onClick={() => handleLogsDownloadExcel(data.boarddoc.id)}
            icon={<ExcelIcon fill={'#fff'} />}
          >
            {t('Export')}
          </Button>
        </Col>
      </Row>
      <PageHeader title={data?.boarddoc?.title} />
      <div className={styles.container}>
        <Filters
          onChange={handleChangeFilters}
          onClose={handleCloseFilter}
          filters={filters}
        />
        <Divider />
        <Table
          loading={loading}
          columns={columns}
          dataSource={data.logs}
          onChange={onChangeTableFilter}
          pagination={data.pagination}
        />
      </div>
    </>
  );
};

export default LogsPage;
